import styled from '@emotion/styled';
import { ImageGrid } from 'src/components-dummy';

export const GridItemStyled = styled(ImageGrid.DraggableGridItem)`
  display: flex;
  justify-content: center;
  aspect-ratio: 1 / 1;
  cursor: pointer;
`;
